export const INITIAL_GEO_OBJECT = {
  userInput: 'Москва',
  address: [],
  highways: [],
  undergrounds: [],
  countryId: 138,
  geoId: null,
  geoType: null,
};
